import { render } from "./InterfaceWysiwyg.vue?vue&type=template&id=5a8b4cbe&scoped=true"
import script from "./InterfaceWysiwyg.vue?vue&type=script&lang=js"
export * from "./InterfaceWysiwyg.vue?vue&type=script&lang=js"

import "./InterfaceWysiwyg.vue?vue&type=style&index=0&id=5a8b4cbe&scoped=true&lang=scss"

import exportComponent from "/tmp/ef98a231-0263-404c-a747-c31ac6c86af7/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a8b4cbe"]])

export default __exports__